import React from "react";

export const Image = ({
  source,
  description = "",
  className,
}: {
  source: string;
  description?: string;
  className?: string;
}) => {
  return <img src={source} alt={description} className={className} />;
};
